export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Виберіть рахунок оферента"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Рахунок оферента"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Account"])}
}